import { SET_COMPLIANCE_APP_PERMISSONS, SET_COMPLIANCE_CONFIG, SET_COMPLIANCE_MAIN_TAB_DATA, SET_COMPLIANCE_MAIN_ACTIVE_TAB, SET_COMPLIANCE_MAIN_DISABLED_TAB } from './actionTypes'

export const setComplianceAppPermissions = (complianceAppPermissions) => {
    return {
        type : SET_COMPLIANCE_APP_PERMISSONS,
        complianceAppPermissions : complianceAppPermissions
    }
}

export const setComplianceConfig = (complianceConfig) => {
    return {
        type : SET_COMPLIANCE_CONFIG,
        complianceConfig : complianceConfig
    }
}

export const setComplianceMainActiveTab = (activeTab) => {
    return {
        type : SET_COMPLIANCE_MAIN_ACTIVE_TAB,
        info : "Comp active tab redux action :",
        compActiveTab : {active:activeTab}
    }
}

export const setComplianceMainDisabledTab = (disabledTab) => {
    return {
        type : SET_COMPLIANCE_MAIN_DISABLED_TAB,
        info : "Comp disabled tab redux action :",
        compDisabledTab : {disabled:disabledTab}
    }
}

export const setComplianceMainTabData = (tabData) => {
    return {
        type : SET_COMPLIANCE_MAIN_TAB_DATA,
        info : "Comp tab data redux action :",
        compTabdata : tabData
    }
}